import React from 'react';
import { LibraryItem } from '../types';
import { UniverseCardBack } from './UniverseCardFace';
import overtureLogo from '../../../shared/assets/images/brand/overture-logo.png';

export type UniverseBackStyle = 'actual' | 'overture' | 'white';
export const OVERTURE_SITE_URL = 'https://www.overtureai.org/';

export function UniversePrintBack({ card, style, qrUrl }: { card: LibraryItem; style: UniverseBackStyle; qrUrl?: string }) {
  if (style === 'actual') return <UniverseCardBack card={card} qrUrl={qrUrl} />;
  return <article className={`universe-print-brand-back universe-print-brand-back--${style}`}>
    <div className="universe-print-brand-mark" aria-hidden="true">✦</div>
    <img className="universe-print-brand-logo" src={overtureLogo} alt="Overture" />
    {style === 'overture' ? <><strong>UNIVERSE</strong><span className="universe-print-brand-tagline">Made to imagine. Made to share.</span></> : <>{qrUrl && <img className="universe-print-brand-qr" src={qrUrl} alt="QR code linking to overtureai.org" />}<span className="universe-print-brand-link">www.overtureai.org</span></>}
  </article>;
}
